import { put, call, takeEvery } from 'typed-redux-saga';
import AdminGateway from '~apis/admin';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { AuthUserStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchExportAdminUserListing(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminExportAdminUserListingAttempt', handleExportAdminUserListing, api);
}

function* handleExportAdminUserListing(api: AdminGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { filters: { status, email, branchId } } = reduxState.admin.adminListing;

    const response = yield* call([api, api.exportAdminUserListing], { 
        authToken,
        email: email || undefined,
        branchId: branchId || undefined,
        status: UtilFunctions.Misc.getEnumValueByKey(AuthUserStatusEnum, status),
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminExportAdminUserListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminExportAdminUserListingSuccess(response.data));
    }
}
